import { ids } from "@icarros/theme-react";
import { hexToRgba } from "@icarros/utils-react";
import styled, { css } from "styled-components";
import { Contrast } from "../../../types/general.types";
const { size, color, opacity } = ids || {};
const defaultStyle = css `
  background: ${hexToRgba(color.action.secondary.ids_color_action_secondary_base, opacity.ids_opacity_empty)};
  color: ${color.action.secondary.ids_color_action_secondary_contrast};
  border-color: ${color.action.secondary.ids_color_action_secondary_base};
  &:hover,
  &:active {
    border-color: ${color.action.secondary.ids_color_action_secondary_variant};
    color: ${color.action.secondary.ids_color_action_secondary_variant};
    background: ${hexToRgba(color.action.secondary.ids_color_action_secondary_variant, opacity.ids_opacity_soft)};
  }
`;
const defaultDisabled = css `
  background: ${hexToRgba(color.action.disabled.ids_color_action_disabled_base, opacity.ids_opacity_empty)};
  color: ${color.action.disabled.ids_color_action_disabled_variant};
  border-color: ${color.action.disabled.ids_color_action_disabled_base};
`;
const defaultOnDark = css `
  background: ${(props) => props.isDisabled
    ? hexToRgba(color.contrast.ids_color_contrast_onDark, opacity.ids_opacity_empty)
    : hexToRgba(color.contrast.ids_color_contrast_onDark, opacity.ids_opacity_empty)};
  color: ${(props) => props.isDisabled
    ? hexToRgba(color.contrast.ids_color_contrast_onDark, opacity.ids_opacity_medium)
    : color.contrast.ids_color_contrast_onDark};
  border-color: ${(props) => props.isDisabled
    ? hexToRgba(color.contrast.ids_color_contrast_onDark, opacity.ids_opacity_strong)
    : color.contrast.ids_color_contrast_onDark};
  &:hover,
  &:active {
    background: ${hexToRgba(color.contrast.ids_color_contrast_onDark, opacity.ids_opacity_soft)};
  }
`;
const defaultOnLight = css `
  background: ${(props) => props.isDisabled
    ? hexToRgba(color.contrast.ids_color_contrast_onLight, opacity.ids_opacity_empty)
    : hexToRgba(color.contrast.ids_color_contrast_onLight, opacity.ids_opacity_empty)};
  color: ${(props) => props.isDisabled
    ? hexToRgba(color.contrast.ids_color_contrast_onLight, opacity.ids_opacity_medium)
    : color.contrast.ids_color_contrast_onLight};
  border-color: ${(props) => props.isDisabled
    ? hexToRgba(color.contrast.ids_color_contrast_onLight, opacity.ids_opacity_medium)
    : color.contrast.ids_color_contrast_onLight};
  &:hover,
  &:active {
    background: ${hexToRgba(color.contrast.ids_color_contrast_onLight, opacity.ids_opacity_soft)};
  }
`;
const getButtonKindStyle = (isDisabled, contrast) => {
    if (contrast === Contrast.dark)
        return defaultOnDark;
    if (contrast === Contrast.light)
        return defaultOnLight;
    if (isDisabled)
        return defaultDisabled;
    return defaultStyle;
};
const StyledButton = styled.button `
  height: ${size.general.ids_size_general_32x};
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px ${size.general.ids_size_general_16x}};
  border-radius: ${ids.size.corner_radius.ids_size_cornerRadius_smallButton};
  border-width: ${ids.size.border_width.ids_size_border_small};
  border-style: solid;
  cursor: pointer;
  ${({ isDisabled, contrast }) => getButtonKindStyle(isDisabled, contrast)}
`;
export default StyledButton;
//# sourceMappingURL=Contextual.style.js.map